export type GoalId =
  | 'rest_and_sleep_better'
  | 'feel_better_in_your_body'
  | 'make_movement_a_habit'
  | 'feel_calmer_under_stress'
  | 'find_your_focus'
  | 'nail_your_nutrition'
  | 'build_better_money_habits';

export const GOAL_IDS: GoalId[] = [
  'rest_and_sleep_better',
  'feel_better_in_your_body',
  'make_movement_a_habit',
  'feel_calmer_under_stress',
  'find_your_focus',
  'nail_your_nutrition',
  'build_better_money_habits',
];
